var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIconFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0156 1.98645C17.2805 1.99059 17.5329 2.09957 17.7175 2.28949C17.902 2.4794 18.0036 2.73472 18 2.99942V3.99873H19C20.0931 3.99873 21 4.90505 21 5.99736V19.9877C21 21.08 20.0931 21.9863 19 21.9863H5C3.90694 21.9863 3 21.08 3 19.9877V5.99736C3 4.90505 3.90694 3.99873 5 3.99873H6V2.99942C5.99817 2.86573 6.0232 2.73302 6.07362 2.60917C6.12403 2.48531 6.19881 2.37282 6.29351 2.27837C6.38821 2.18391 6.50092 2.10941 6.62496 2.05926C6.74899 2.00912 6.88184 1.98436 7.01562 1.98645C7.2805 1.99059 7.53291 2.09957 7.71746 2.28949C7.90201 2.4794 8.00363 2.73472 8 2.99942V3.99873H16V2.99942C15.9982 2.86573 16.0232 2.73302 16.0736 2.60917C16.124 2.48531 16.1988 2.37282 16.2935 2.27837C16.3882 2.18391 16.5009 2.10941 16.625 2.05926C16.749 2.00912 16.8818 1.98436 17.0156 1.98645ZM19 8.99529H5V19.9877H19V8.99529ZM11 12.9925C11.552 12.9925 12 13.4402 12 13.9918V16.9898C12 17.5414 11.552 17.9891 11 17.9891H8C7.448 17.9891 7 17.5414 7 16.9898V13.9918C7 13.4402 7.448 12.9925 8 12.9925H11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIconFigma);
export default __webpack_public_path__ + "static/media/calendar-icon-figma.1c75b09d0c62d86efdba4793943bf623.svg";
export { ForwardRef as ReactComponent };